import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import translationEN from './locales/en.json';
import translationNL from './locales/nl.json';
import translationDE from './locales/de.json';
import translationFR from './locales/fr.json';

const resources = {
  en: { translation: translationEN },
  nl: { translation: translationNL },
  de: { translation: translationDE },
  fr: { translation: translationFR }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    supportedLngs: ['en', 'nl', 'de', 'fr'],
    nonExplicitSupportedLngs: true,
    debug: false,
    interpolation: {
      escapeValue: false
    },
    detection: {
      order: ['querystring', 'localStorage', 'navigator'],
      lookupQuerystring: 'lang',
      caches: ['localStorage']
    }
  });

// Keep <html lang> in sync with the active i18n language. This matters for
// a11y, SEO, and ads QA: a NL ad landing must report `<html lang="nl">`.
function syncHtmlLang(lng) {
  if (typeof document === 'undefined' || !lng) return;
  const short = String(lng).split('-')[0].toLowerCase();
  document.documentElement.setAttribute('lang', short);
}
syncHtmlLang(i18n.language);
i18n.on('languageChanged', syncHtmlLang);

export default i18n;
